import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { closeModal } from 'modal/store/actions';
import { getSpaceSelectOptions } from 'spaces/store/selectors';
import FormikSelectField from 'base/components/forms/formik/FormikSelectField';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3';
import MainTitle from 'base/components/MainTitle';
import SubmitButton from 'base/components/forms/SubmitButton';
import ModalHeader from 'modal/components/ModalHeader';
import { getEditingFolder, getActivePathStringWithSpace } from '../../store/folders/selectors';
import { updateFolder } from '../../store/folders/actions';


const CreateFolderModal = ({
  name, folder, updateFolder, closeModal, activePathString, spaceSelectOptions,
}) => (
  <>
    <ModalHeader>
      <MainTitle>Edit Folder</MainTitle>
    </ModalHeader>

    <FieldWrapper>
      <Title3>{activePathString}</Title3>
    </FieldWrapper>

    <Formik
      initialValues={{
        name: folder.name,
        space: folder.space,
      }}
      validationSchema={
          Yup.object().shape({
            name: Yup.string()
              .required('Name is required.'),
          })
        }
      render={({ errors, isSubmitting }) => ( // eslint-disable-line
        <Form>
          <Field
            type="text"
            name="name"
            placeholder="Name"
            component={FormikInputField}
            autoFocus
          />

          <Field
            type="select"
            name="space"
            component={FormikSelectField}
            label="Space"
            options={spaceSelectOptions}
          />

          <FieldWrapper>
              Note: if you want to move the folder, you can simply
              drag and drop the folder in the folder tree.
          </FieldWrapper>

          <SubmitButton type="submit" disabled={isSubmitting}>
              Update Folder
          </SubmitButton>
        </Form>
      )}
      onSubmit={(values) => {
        const updatedFolder = {
          ...folder,
          name: values.name,
          space: values.space,
          parent: values.space !== folder.space ? null : folder.parent,
        };
        updateFolder(updatedFolder);
        closeModal(name);
      }}
    />
  </>
);
CreateFolderModal.propTypes = {
  name: PropTypes.string.isRequired,
  folder: PropTypes.objectOf(PropTypes.any).isRequired,
  updateFolder: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  activePathString: PropTypes.string.isRequired,
  spaceSelectOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const mapStateToProps = (state) => ({
  folder: getEditingFolder(state),
  activePathString: getActivePathStringWithSpace(state),
  spaceSelectOptions: getSpaceSelectOptions(state),
});

const mapDispatchToProps = {
  updateFolder,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFolderModal);
